import { Grid, TextField, Box, IconButton, Chip, Switch, FormControlLabel } from '@mui/material';
import SendIcon from "@mui/icons-material/Send";
import MailIcon from "@mui/icons-material/Mail";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { useTranslation } from 'react-i18next';
import '../styles/MeetingParticipantsSection.css';

const EMAIL_REGEX = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/;

export default function MeetingParticipantsSection({
    titoloRiunione,
    setTitoloRiunione,
    invioNotifica,
    setInvioNotifica,
    participantsList,
    setParticipantsList,
    partecipanteInput,
    setPartecipanteInput
}) {
    const { t } = useTranslation();

    const handleAddParticipant = () => {
        if (partecipanteInput.trim() !== '') {
            setParticipantsList([...participantsList, partecipanteInput.trim().toUpperCase()]);
            setPartecipanteInput("");
        }
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            handleAddParticipant();
        }
    };

    const handleRemoveParticipant = (indexToRemove) => {
        setParticipantsList(participantsList.filter((_, idx) => idx !== indexToRemove));
    };

    return (
        <>
            <Grid item xs={12}>
                <Box sx={{
                    display: 'flex',
                    flexDirection: { xs: 'column', sm: 'row' },
                    gap: 2,
                    alignItems: { xs: 'flex-start', sm: 'center' }
                }}>
                    <TextField
                        label={t("Meeting_Title")}
                        value={titoloRiunione}
                        onChange={(e) => setTitoloRiunione(e.target.value)}
                        variant="standard"
                        sx={{ flex: 1, width: '100%' }}
                    />
                    <FormControlLabel
                        control={
                            <Switch
                                checked={invioNotifica}
                                onChange={(e) => setInvioNotifica(e.target.checked)}
                            />
                        }
                        label={t("Invite_email")}
                    />
                </Box>
            </Grid>

            {/* Input Partecipanti */}
            <Grid item xs={12}>
                <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                    <TextField
                        label={t("Meeting_Participants")}
                        value={partecipanteInput}
                        onChange={(e) => setPartecipanteInput(e.target.value)}
                        variant="standard"
                        sx={{ flex: 1 }}
                        onKeyPress={handleKeyPress}
                    />
                    <IconButton
                        color="primary"
                        disabled={!partecipanteInput.trim()}
                        onClick={handleAddParticipant}
                    >
                        <SendIcon fontSize="small" />
                    </IconButton>
                </Box>

                {/* Lista Chip Partecipanti */}
                <div className="meeting-participants-chip-area">
                    {participantsList.map((p, idx) => (
                        <Chip
                            key={idx}
                            label={p}
                            onDelete={() => handleRemoveParticipant(idx)}
                            size="small"
                            color="primary"
                            variant="outlined"
                            icon={EMAIL_REGEX.test(p) ? <MailIcon /> : <AccountCircleIcon />}
                        />
                    ))}
                </div>
            </Grid>
        </>
    );
}
